import { FC } from 'react';

import { CampaignGender } from 'utils/constants/campaign';

import useTrls from 'hooks/translation/useTrls';

const Gender: FC<{ sex: CampaignGender }> = ({ sex }) => {
    const trl = useTrls();

    return (
        <p>
            {trl('campaign.targetings.sex.item')}: {trl(`campaign.targetings.sex.${sex}`)}
        </p>
    );
};

export default Gender;
